import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiArrowUpRight}=FiIcons;

const SuiteHeader=({onApply,onQualify})=> (
  <>
    <div className="border-b border-black bg-black px-4 py-2 text-center text-[10px] font-bold uppercase tracking-[0.16em] text-white sm:text-xs">
      Elite Sales &amp; Automation · Application Only
    </div>

    <header className="sticky top-0 z-40 border-b border-black bg-white px-4 py-4 sm:px-8">
      <div className="mx-auto flex max-w-5xl items-center justify-between">
        <button
          className="text-left"
          onClick={()=> window.scrollTo({top: 0,behavior: 'smooth'})}
        >
          <span className="block text-base font-black uppercase tracking-[0.08em] text-black">
            Elite Sales
          </span>
          <span className="block text-[10px] font-bold uppercase tracking-[0.14em] text-neutral-500">
            &amp; Automation
          </span>
        </button>

        <div className="flex items-center gap-4">
          <button
            onClick={onQualify}
            className="hidden text-xs font-bold uppercase tracking-wide text-neutral-700 underline underline-offset-4 sm:block"
          >
            The Offer
          </button>

          <button
            onClick={onApply}
            className="flex items-center gap-2 border border-black bg-black px-4 py-2.5 text-xs font-black uppercase tracking-wide text-white transition hover:bg-neutral-800"
          >
            Apply
            <SafeIcon icon={FiArrowUpRight} />
          </button>
        </div>
      </div>
    </header>
  </>
);

export default SuiteHeader;